import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Label } from '../../../label/Label.mjs';
import { useFormFieldContext } from '../../context.mjs';

const FormFieldLabel = forwardRef(
  ({
    disabled: disabledFromProps,
    required: requiredFromProps,
    state: stateFromProps,
    ...props
  }, forwardedRef) => {
    const {
      disabled: disabledFromContext,
      required: requiredFromContext,
      state: stateFromContext
    } = useFormFieldContext("FormField.Label");
    return /* @__PURE__ */ jsx(
      Label,
      {
        "data-scope": "form-field",
        "data-part": "label",
        disabled: disabledFromProps ?? disabledFromContext,
        required: requiredFromProps ?? requiredFromContext,
        state: stateFromProps ?? stateFromContext,
        ref: forwardedRef,
        ...props
      }
    );
  }
);
FormFieldLabel.displayName = "FormField.Label";

export { FormFieldLabel };
//# sourceMappingURL=Label.mjs.map
